import { render } from "./TodoList.vue?vue&type=template&id=4349c8bc&scoped=true"
import script from "./TodoList.vue?vue&type=script&lang=js"
export * from "./TodoList.vue?vue&type=script&lang=js"

import "./TodoList.vue?vue&type=style&index=0&id=4349c8bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4349c8bc"]])

export default __exports__